/** Sticky public top menu (AppBar + toolbar content). */
export const PUBLIC_TOP_MENU_HEIGHT_PX = 80;

/** Live height of the public AppBar, set by TopMenu. */
export const PUBLIC_TOP_MENU_HEIGHT_VAR = '--public-top-menu-height';
export const PUBLIC_TOP_MENU_SELECTOR = '[data-public-top-menu]';

/** MUI Container `pt: 2` on public pages (theme spacing 8). */
const PUBLIC_PAGE_CONTAINER_TOP_PADDING_PX = 16;

export function publicHeroUnderMenuOverlapPx(containerTopPadding = PUBLIC_PAGE_CONTAINER_TOP_PADDING_PX) {
  return PUBLIC_TOP_MENU_HEIGHT_PX + containerTopPadding;
}

export function isPublicHomePath(pathname: string): boolean {
  if (pathname.includes('/dashboard/')) return false;
  if (pathname === '/home' || pathname.endsWith('/home')) return true;
  return /^\/(en|hu|ro)\/?$/.test(pathname);
}
